import {Button} from 'antd';
import {FormattedMessage} from 'react-intl';
import Icon from '../Icon/Icon';
import Tag from '../Tag/Tag';
import styles from './DropdownMenu.module.scss';
import useDropdownMenu from './useDropdownMenu';
import { Props } from './DropdownMenu.model';
import Navbar from '../Navbar/Navbar';
import useHandleWindowSize from '../../Helpers/useHandleWindowSize';
import CreateFeedback from '../CreateFeedback/CreateFeedback';
import HelpRequest from '../HelpRequest/HelpRequest';

const DropdownMenu = ({onClose, isOpen}: Props) => {
	const {
		navigate,
		onLogout,
		state: { email, fullName, imageId, role, showFeedbackPopup, showHelpPopup},
		toggleFeedbackPopup,
		toggleHelpPopup
	} = useDropdownMenu();

	const {
		state: { width },
	} = useHandleWindowSize();

	return (
		<>
			<div className={`${styles.dropdownContainer} ${isOpen ? styles.isOpen : ''}`}>
				<div
					className={`${
						width < 1024 ? styles.dropdownWrapperMobile : styles.dropdownWrapper
					} ${styles.topBorder} ${(width < 1024 && isOpen) ? styles.sideNavOpen : ''}`}
				>
					<div className={`${styles.section} ${styles.border}`}>
						<div className={styles.item}>
							<div
								className={styles.user}
								onClick={() => {
									if (role === 'Admin') {
										navigate('/users/admin-profile');
									} else {
										navigate('/my-profile');
									}
									onClose();
								}}
							>
								{imageId ? (
									<div className={styles.iconContainer}>
										<img alt="" src={imageId} className={styles.avatarImage}/>
									</div>
								) : (
									<div className={styles.iconContainer}>
										<div className={styles.avatar}>
											<Icon
												color="text"
												height="12px"
												name="user"
												width="12px"
											/>
										</div>
									</div>
								)}
								<div className={styles.info}>
									<div>{fullName || email}</div>
									<Tag>{role}</Tag>
								</div>
							</div>
						</div>
					</div>
					<div
						className={`${styles.section} ${styles.navbar} ${styles.border}`}
					>
						<Navbar orientation="vertical" onClickItem={onClose}/>
					</div>
					{role !== 'Admin' && (
						<div className={`${styles.section} ${styles.border}`}>
							<div className={styles.item}>
								<div className={styles.iconContainer}>
									<Icon
										color="text"
										height="16px"
										name="settings"
										width="16px"
									/>
								</div>
								<Button
									type="link"
									onClick={() => {
										navigate('/edit-my-profile?tab=settings');
										onClose();
									}}
								>
									<FormattedMessage id="buttons.accountSettings"/>
								</Button>
							</div>
							<div className={styles.item}>
								<div className={styles.iconContainer}>
									<Icon
										color="text"
										height="16px"
										name="comment-alt-edit"
										type="solid"
										width="16px"
									/>
								</div>
								<Button
									type="link"
									onClick={toggleFeedbackPopup}
								>
									<FormattedMessage id="buttons.giveFeedback"/>
								</Button>
							</div>
								<div className={styles.item}>
								<div className={styles.iconContainer}>
									<Icon
										color="text"
										height="16px"
										name="life-ring"
										type="solid"
										width="16px"
									/>
								</div>
								<Button
									type="link"
									onClick={toggleHelpPopup}
								>
									<FormattedMessage id="buttons.help"/>
								</Button>
							</div>
						</div>
					)}
					{role === 'Admin' && <div className={`${styles.section} ${styles.border}`}>
							<div className={styles.item}>
								<div className={styles.iconContainer}>
									<Icon
										color="text"
										height="16px"
										name="clipboard-list"
										width="16px"
									/>
								</div>
								<Button
									type="link"
									onClick={() => {
										navigate('/lnlm-conferences');
										onClose();
									}}
								>
									<FormattedMessage id="buttons.LNLMconferences"/>
								</Button>
						</div>
						<div className={styles.item}>
							<div className={styles.iconContainer}>
								<Icon
									color="text"
									height="16px"
									name="user-tie"
									width="16px"
								/>
							</div>
							<Button
								type="link"
								onClick={() => {
									navigate('/lnlm-attendants');
									onClose();
								}}
							>
								<FormattedMessage id="buttons.lnlmAttendants"/>
							</Button>
						</div>
						<div className={styles.item}>
							<div className={styles.iconContainer}>
								<Icon
									color="text"
									height="16px"
									name="level-up"
									width="16px"
								/>
							</div>
							<Button
								type="link"
								onClick={() => {
									navigate('/upgrade-request');
									onClose();
								}}
							>
								<FormattedMessage id="navigation.upgradeRequests"/>
							</Button>
						</div>
						<div className={styles.item}>
							<div className={styles.iconContainer}>
								<Icon
									color="text"
									height="16px"
									name="poll"
									width="16px"
								/>
							</div>
							<Button
								type="link"
								onClick={() => {
									navigate('/surveys');
									onClose();
								}}
							>
								<FormattedMessage id="navigation.survey"/>
							</Button>
						</div>
						<div className={styles.item}>
							<div className={styles.iconContainer}>
								<Icon
									color="text"
									height="16px"
									name="chart-bar"
									width="16px"
								/>
							</div>
							<Button
								type="link"
								onClick={() => {
									navigate('/statistics');
									onClose();
								}}
							>
								<FormattedMessage id="navigation.statistics"/>
							</Button>
						</div>
					</div>
					}
					<div
						className={`${styles.section} ${styles.border} ${
							width < 1024 ? styles.signOutContainerMobile : ''
						}`}
					>
						<div className={styles.item}>
							<div className={styles.iconContainer}>
								<Icon color="red" height="16px" name="sign-out" width="16px"/>
							</div>
							<Button
								className={styles.redBtn}
								type="link"
								onClick={() => {
									onLogout();
									onClose();
								}}
							>
								<FormattedMessage id="buttons.logout"/>
							</Button>
						</div>
					</div>
				</div>
			</div>
			{showFeedbackPopup && <CreateFeedback onClose={toggleFeedbackPopup} />}
			{showHelpPopup && <HelpRequest onClose={toggleHelpPopup} />}
		</>
	);
};
export default DropdownMenu; 
